// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

// Custom file imports
import wrapPage from './util/wrap-page.js'


export const wrapPageElement = wrapPage